import { render, staticRenderFns } from "./TabelaPoliticaVendas.vue?vue&type=template&id=06ec58f7&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./TabelaPoliticaVendas.vue?vue&type=script&lang=js&"
export * from "./TabelaPoliticaVendas.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPoliticaVendas.vue?vue&type=style&index=0&id=06ec58f7&lang=scss&scoped=true&"
import style1 from "./TabelaPoliticaVendas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ec58f7",
  null
  
)

export default component.exports